<template>
    <li :class="['message', { active: isActive }]">
        <a href="javascript:void()" @click="showGroupView()" class="pt-5 pb-4">
            <div class="actions mr-2">
                <span class="ml-3"><i class="icon icon-speech"></i></span>
            </div>
            <div class="header ml-1 d-block">
                <span class="from">{{ `${group.name} (${group.total_templates})` }}</span>
                <span class="pull-right"><span class="badge badge-secondary badge-pill"> <small>{{ group.personal ? 'Private' : 'Public' }}</small></span></span>
            </div>
        </a>
    </li>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'GroupItem',
  components: {
  },
  props: {
    group: {
      type: Object,
      default: null
    },
    isActive: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
    }
  },
  methods: {
    showGroupView: function() {
      this.$emit('show-template-group-view', this.group)
    },
  }
}
</script>
